import noUiSlider from 'nouislider';
import CatalogAjax from '../catalogAjax/catalogAjax';
import UrlGeneration from '@lovata/url-generation';

export default new class FilterChecked {
    constructor() {
        this.sClearButtonClass = 'clear-filter';

        this.init();
    }
    init() {
        $(document).on('click', `.${this.sClearButtonClass}`, () => {
            UrlGeneration.clear();
            CatalogAjax.updateAllAjax();
        });
    }
}();
